import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'sirsim-menu-dropdown',
  templateUrl: './menu-dropdown.component.html',
  styleUrls: ['./menu-dropdown.component.scss'],
})
export class MenuDropdownComponent implements OnInit {
  styles: any = {};
  visible: boolean = false;
  target: any;

  @ViewChild('op', { static: true }) overlay: ElementRef;
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.position(event, this.target);
  }

  ngOnInit() {
    this.styles.visibility = this.visible ? 'inherit' : 'hidden';
  }

  public toggle(event: MouseEvent, targetEl): void {
    this.target = targetEl;
    this.setVisibility(!this.visible);
    if (this.visible) {
      this.position(event, targetEl);
    }
  }

  private setVisibility(val: boolean) {
    this.visible = val;
    this.styles.visibility = this.visible ? 'inherit' : 'hidden';
  }

  private position(event, targetEl) {
    const viewport = this.getViewport();
    if (targetEl) {
      const rect = this.overlay.nativeElement.getBoundingClientRect();
      const target = targetEl.getBoundingClientRect();
      const diff = target.left + rect.width - viewport.width;

      if (viewport.width <= 400) {
        this.styles.left = target.left - (rect.width - target.width) + 'px';
      } else {
        this.styles.left = target.left + diff + 'px';
      }
      this.styles.top = target.bottom + 4 + 'px';
    }
  }

  private getViewport(): any {
    let win = window,
      d = document,
      e = d.documentElement,
      g = d.getElementsByTagName('body')[0],
      w = win.innerWidth || e.clientWidth || g.clientWidth,
      h = win.innerHeight || e.clientHeight || g.clientHeight;

    return { width: w, height: h };
  }

  @HostListener('window:click', ['$event'])
  private click(event: Event) {
    if (
      event
        .composedPath()
        .findIndex(
          (x) =>
            (<HTMLElement>x).classList?.contains('prs-menu-dropdown-trigger') ||
            (<HTMLElement>x).classList?.contains('prs-dropdown')
        ) === -1
    ) {
      this.setVisibility(false);
    }
  }
}
